module.exports = __webpack_public_path__ + "static/img/hh-shower.cdc1cd3e.png";